import styled from '@app/styled';
import { color, mediaQuery, spacing, typography } from '@app/theme';

const tutorialMaxWidth = `310px`;

export const Layout = styled.div`
    display: grid;
    gap: ${spacing(7)};

    ${mediaQuery.min('lg')} {
        grid-template-columns: auto ${tutorialMaxWidth};
    }
`;

export const SidePageWrap = styled.div`
    min-width: 100%;
    max-width: ${tutorialMaxWidth};
    display: grid;
    gap: ${spacing(2)};
    grid-auto-rows: min-content;
    grid-template-columns: 1fr;
    ${mediaQuery.min('sm')} {
        grid-template-columns: max-content max-content max-content;

        width: 100%;
    }

    ${mediaQuery.max('lg')} {
        grid-row-start: 1;
    }

    ${mediaQuery.min('lg')} {
        grid-auto-rows: min-content;
        grid-template-columns: 1fr;
    }
`;

export const QuickDownloadTitle = styled.span`
    ${typography('custom.descriptionMedium')};
    color: ${color('text.default')};
`;
